function colorChange(element){
  var color = element.getAttribute('data-color');
  var div = document.querySelector('.variant-title'); 
  div.textContent = color; 
}

function toggleHide(id){
   var element = document.getElementById(id);

  if (element.classList.contains('display-none')) {
    element.classList.remove('display-none');
  } else {
    element.classList.add('display-none');
  }
}

document.addEventListener('DOMContentLoaded', function() {
DisplayLocalElements()
  const brElements = document.querySelectorAll('.the-details-accordian div br');

  brElements.forEach(function(brElement) {
  


    // get all text after the br element and wrap it in a span
    var text = brElement.nextSibling;
    var span = document.createElement('span');
    span.appendChild(text);
    brElement.parentNode.appendChild(span);

    // remove the br element
    brElement.parentNode.removeChild(brElement);


  });

})

// dISPLAY lOCATION iTEMS
function DisplayLocalElements(){
  var country = Shopify.country;

    switch(country){
      case "US":
          // Get all elements with class 'uk-show'
      var usElements = document.querySelectorAll('.us-show');
      // Iterate through the elements and remove the 'location-hide' class
      usElements.forEach(function(element) {
        element.classList.remove('location-hide');
      });
        break;
      case "GB":
        // Get all elements with class 'uk-show'
      var ukElements = document.querySelectorAll('.uk-show');
      // Iterate through the elements and remove the 'location-hide' class
      ukElements.forEach(function(element) {
        element.classList.remove('location-hide');
      });
        break;
        default:
      // Handle all other countries
      var defaultElements = document.querySelectorAll('.default-show');
      defaultElements.forEach(function(element) {
        element.classList.remove('location-hide');
      });
      break;
    }
}

/*document.getElementById("klaviyo-signup-embedded-subscribe").onclick = function() {
  var elements = document.getElementsByClassName("signup-content");

  // Loop through the elements and hide each one
  for (var i = 0; i < elements.length; i++) {
    elements[i].style.display = "none";
  }
};*/